import { render, staticRenderFns } from "./OTags.vue?vue&type=template&id=67be02ef&scoped=true&"
import script from "./OTags.vue?vue&type=script&lang=js&"
export * from "./OTags.vue?vue&type=script&lang=js&"
import style0 from "./OTags.vue?vue&type=style&index=0&id=67be02ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be02ef",
  null
  
)

export default component.exports